export * as MainCarousel from "./MainCarousel";
export { default as PdpBottomCarousels } from "./PdpBottomCarousels";
export { default as PdpFitGuide } from "./PdpFitGuide";
export { default as PincodeBlock } from "./PincodeBlock";
export { default as ThumbNailCarousel } from "./ThumbNailCarousel";
export { default as PdpBannerSlot } from "./PdpBannerSlot";
export { default as PdpNonReturnBlock } from "./PdpNonReturnBlock";



// WEBPACK FOOTER //
// ./src/component/PdpComponents/index.js